<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  [style]="{width: '440px', maxWidth: '90vw'}"
  [blockScroll]="true"
  [focusOnShow]="false"
  styleClass="branduals-dialog provenance-dialog"
  (keydown)="onDialogKeydown($event)"
  [appDialogEscape]="visible()"
  (escapePressed)="guardedClose()">

  <!-- PrimeNG's header is off: the dialog owns its close gesture (X, Cancel, Escape all ask
       before discarding typed work), so the header row is its own. -->
  <app-guarded-dialog-header [title]="title()" [disabled]="busy()" (close)="guardedClose()" />
  <p class="dialog-subtitle">{{ 'compliance.provenanceDialog.subtitle' | translate }}</p>

  <div class="form-field">
    <label class="field-label">{{ 'compliance.provenanceDialog.fields.origin' | translate }}</label>
    <p-select [options]="originOptions" optionValue="value" optionLabel="label"
      [ngModel]="origin()" (ngModelChange)="onOriginChange($event)" appendTo="body"
      appSelectChord (chordSend)="onChordSend()">
      <ng-template let-o pTemplate="selectedItem"><span>{{ o.label | translate }}</span></ng-template>
      <ng-template let-o pTemplate="item"><span>{{ o.label | translate }}</span></ng-template>
    </p-select>
  </div>

  @if (aiTrio()) {
    <div class="form-field">
      <label class="field-label">{{ 'compliance.provenanceDialog.fields.aiModel' | translate }}</label>
      <input pInputText type="text"
        [placeholder]="'compliance.provenanceDialog.fields.aiModelPlaceholder' | translate"
        [ngModel]="aiModel()" (ngModelChange)="aiModel.set($event)">
    </div>
    <div class="form-field">
      <label class="field-label">{{ 'compliance.provenanceDialog.fields.aiPrompt' | translate }}</label>
      <textarea pTextarea rows="3"
        [placeholder]="'compliance.provenanceDialog.fields.aiPromptPlaceholder' | translate"
        [ngModel]="aiPrompt()" (ngModelChange)="aiPrompt.set($event)"></textarea>
    </div>
  }

  @if (showSource()) {
    <div class="form-field">
      <label class="field-label">{{ 'compliance.provenanceDialog.fields.source' | translate }}</label>
      <input pInputText type="text"
        [placeholder]="'compliance.provenanceDialog.fields.sourcePlaceholder' | translate"
        [ngModel]="sourceInfo()" (ngModelChange)="sourceInfo.set($event)">
    </div>
  }

  <div class="form-field field-toggle">
    <div class="toggle-row">
      <label class="field-label">{{ 'compliance.provenanceDialog.fields.disclosure' | translate }}</label>
      <p-toggleswitch [ngModel]="disclosureRequired()" (ngModelChange)="disclosureRequired.set($event)" />
    </div>
    <span class="field-hint">{{ 'compliance.provenanceDialog.fields.disclosureHint' | translate }}</span>
  </div>

  @if (showReverifyWarning()) {
    <div class="reverify-warning">
      <fa-duotone-icon [icon]="faTriangleExclamation" [fixedWidth]="true" />
      <span>{{ 'compliance.provenanceDialog.reverifyWarning' | translate }}</span>
    </div>
  }

  @if (isBulk()) {
    <p class="bulk-hint">{{ 'compliance.provenanceDialog.bulkHint' | translate }}</p>
  }

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" [disabled]="busy()" (click)="guardedClose()">
      {{ 'common.cancel' | translate }}
    </button>
    <app-submit-chord-hint verb="save" />
    <button pButton type="button" class="p-button-outlined" [disabled]="busy()" (click)="save()">
      @if (busy()) { <fa-duotone-icon [icon]="faSpinnerThird" class="fa-spin" /> }
      {{ 'common.save' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- The discard prompt stacks above the dialog — and above the file preview, when the dialog was
     opened from there — through the family class's z-lift row. -->
<p-confirmDialog styleClass="discard-confirm" />
